const PaymentChannelStates = {
  NOTSET: 'NOT-SET', // Can be Not-Set or Just not available
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
};
export { PaymentChannelStates };
